import React, {useContext, useRef, useState} from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

import CompanyUuidLookup from "../../../Companies/components/CompanyUuidLookup";
import TripReportCriteriaDialogValidator from "../../validators/TripReportCriteriaDialogValidator";
import SystemContext from "../../../../SystemContext";
import moment from 'moment';
import { useTheme } from '@material-ui/core';
import DateSelector from '../../../../controls/DatePicker';
import AirportsLookup from '../../../Airports/components/AirportsLookup';
import useScratchpadUsers from '../../../../services/auth/useScratchPadUsers';
import { useSchedulingScratchPads } from '../../../../services/flightPlanning';
import { useQueryClient } from 'react-query';
import { useAuth0 } from '@auth0/auth0-react';
import { CheckboxEditor, FormCheckbox, FormSelect } from '../../../../controls';
import AircraftLookup from '../../../Aircraft/components/AircraftLookup';


const dateFormat = "DD/MM/YYYY";

const TripReportCriteriaDialog = (props) => {
  const SystemData = useContext(SystemContext);
  const queryClient = useQueryClient();
  const theme = useTheme();
  const { user } = useAuth0();


  const {defaultStartDate, defaultEndDate, selectionFields, defaultCompany, defaultAirline, defaultAirport, defaultScratchPadUser, defaultScratchPad, defaultAircraftReg} = {
    defaultStartDate: moment().startOf('month').toDate(),
    defaultEndDate: moment().endOf('month').toDate(),
    selectionFields: ['dates'],
    defaultCompany: null,
    defaultAirline: null,
    defaultAirport: null,
    defaultAircraftReg: null,
    defaultScratchPadUser: user.sub,
    defaultScratchPad: 0,
    ...props
  }

  const flags = useRef({
    loadedScratchPadUsers: false,
    loadedScratchPads: false,
  });

  const [company, setCompany] = useState(defaultCompany);
  const [airline, setAirline] = useState(defaultAirline);
  const [airport, setAirport] = useState(defaultAirport);
  const [aircraftReg, setAircraftReg] = useState(defaultAircraftReg);
  const [fromDate, setFromDate] = useState(defaultStartDate);
  const [toDate, setToDate] = useState(defaultEndDate);
  const [applyScratchPad, setApplyScratchPad] = useState(false);
  const [scratchPadUser, setScratchPadUser] = useState(defaultScratchPadUser);
  const [scratchPad, setScratchPad] = useState(defaultScratchPad);
  const [excludeAcmi, setExcludeAcmi] = useState(false);
  const [includeAllAircraft, setIncludeAllAircraft] = useState(false);
  const [fileTransfer, setFileTransfer] = useState(false);

  const scratchPadUsers = useScratchpadUsers({queryClient, callback:()=> {
    flags.current.loadedScratchPadUsers = true;
    //console.log(flags);
  }});
  const scratchPads = useSchedulingScratchPads({queryClient, extraKeys: scratchPadUser?[scratchPadUser]:[], callback:()=> {
    flags.current.loadedScratchPads = true;
  }});

  const [validationState, setValidationStatus] = useState({
    error: true,
    errorMessage: "checking",
    field: null
  });

  const handleClose = () => {
    setCompany(null);
    if (props.onChange)
      props.onChange(null);
  };

  const handleSave = () => {
    if (validationState.error) return;
    const params = {};
    if (selectionFields.indexOf('dates') >= 0) {
      params.fromDate = moment(fromDate).format('YYYY-MM-DD');
      params.toDate = moment(toDate).format('YYYY-MM-DD');
    }
    if (selectionFields.indexOf('company') >= 0 || selectionFields.indexOf('customer') >= 0 || selectionFields.indexOf('supplier') >= 0) {
      params.company = company;
    }
    if (selectionFields.indexOf('airline') >= 0) {
      params.airline = airline;
    }
    if (selectionFields.indexOf('airport') >= 0) {
      params.airport = airport;
    }
    if (selectionFields.indexOf('aircraftReg') >= 0) {
      params.aircraftReg = aircraftReg;
    }
    if (selectionFields.indexOf('excludeAcmi') >= 0) {
      params.excludeAcmi = excludeAcmi;
    }
    if (selectionFields.indexOf('includeAllAircraft') >= 0) {
      params.includeAllAircraft = includeAllAircraft;
    }
    if (selectionFields.indexOf('scratchPad') >= 0) {
      params.applyScratchPad = applyScratchPad;
      params.scratchPadUser = scratchPadUser;
      params.scratchPad = scratchPad;
      const scratchPadUuid = scratchPads && Array.isArray(scratchPads.data) && scratchPads.data.length >= scratchPad ? scratchPads.data[scratchPad]?.SchedulingScratchPadUuid : null;
      params.scratchPadUuid = scratchPadUuid;
    }
    if (selectionFields.indexOf('fileTransfer') >= 0) {
      params.fileTransfer = fileTransfer;
    }
    if (props.onChange)
      props.onChange(params);
  };

  const scratchPadUserOptions = scratchPadUsers.data?scratchPadUsers.data.map((scratchPadUser, i) => {
    return {code: scratchPadUser.userId, value: scratchPadUser.name};
  }).sort((u1, u2) => {
    if (u1.code === user.sub) return -1;
    if (u2.code === user.sub) return 1;
    if (u1.value === u2.value) return 0;
    if (u1.value < u2.value) return -1;
    return 1;
  }):null;

  const scratchPadOptions = scratchPads.data?scratchPads.data.map((scratchPad, i) => {
    return {code: i, value: scratchPad.scratchPadName||`Scratch Pad ${i + 1}`};
  }):null;

  if (props.open && flags.current.loadedScratchPadUsers && flags.current.loadedScratchPads) {
    return (
      <div id={"tripReportCriteriaDialog"}>
        <Dialog open={props.open}
                onClose={handleClose}
                aria-labelledby="form-dialog-title"
                disableBackdropClick={true}
        >
          <DialogTitle id="form-dialog-title">
            <div style={{clear: "both", backgroundColor:theme.palette.primary.main, padding:"10px"}}>
              {props.title || "Report Criteria"}
            </div>
          </DialogTitle>
          <DialogContent>
            <DialogContentText>
              {`Please select the criteria to generate the report for`} <br/>
            </DialogContentText>
            <div>
              {selectionFields.map((field, index) => (
                <div key={index} style={{paddingBottom: 10}}>
                {field === "airline" && (
                  <CompanyUuidLookup
                    label="Airline"
                    shrink={true}
                    value={airline ? airline.value : ""}
                    returnType={"object"}
                    companyType="AIRLINE"
                    alwaysShowCompanyName={true}
                    onChange={(returnObject)=> {
                      setAirline(returnObject);
                    }}
                  />
                )}
                {field === "customer" && (
                  <CompanyUuidLookup
                    label="Customer"
                    shrink={true}
                    value={company ? company.value : ""}
                    returnType={"object"}
                    companyType={"CUSTOMER"}
                    alwaysShowCompanyName={true}
                    onChange={(returnObject)=> {
                      setCompany(returnObject);
                    }}
                  />
                )}
                {field === "supplier" && (
                  <CompanyUuidLookup
                    label="Supplier"
                    shrink={true}
                    value={company ? company.value : ""}
                    returnType={"object"}
                    companyType={"SUPPLIER"}
                    alwaysShowCompanyName={true}
                    onChange={(returnObject)=> {
                      setCompany(returnObject);
                    }}
                  />
                )}
                {field === "airport" && (
                  <AirportsLookup
                    label="Airport"
                    shrink={true}
                    value={airport ? airport.value : ""}
                    returnType={"object"}
                    onChange={(returnObject)=> {
                      setAirport(returnObject);
                    }}
                  />
                )}
                  {field === "includeAllAircraft" && (
                    <CheckboxEditor
                      value={includeAllAircraft}
                      label="Include All Aircraft"
                      labelPosition={"end"}
                      onChange={(value) => {
                        if (value === false)
                          setIncludeAllAircraft(false)
                        else
                          setIncludeAllAircraft(true)
                      }}
                    />
                  )}
                {field === "aircraftReg" && !includeAllAircraft && (
                  <AircraftLookup
                    label="Aircraft"
                    id="aircraftReg"
                    inputLabelProps={{shrink: true}}
                    value={aircraftReg ? aircraftReg : ""}
                    onChange={(aircraftTailNumber) => setAircraftReg(aircraftTailNumber)}
                  />
                )}
                {field === "fromDate" && (
                  <DateSelector
                    label="From Date"
                    style={{width: "100%"}}
                    value={fromDate}
                    emptyValue={defaultStartDate}
                    disableToolbar={true}
                    autoOk={true}
                    format={dateFormat}
                    onChange={(value) => {setFromDate(moment(value).format("YYYY-MM-DD"))}}
                  />
                )}
                {field === "toDate" && (
                  <DateSelector
                    label="To Date"
                    style={{width: "100%"}}
                    value={toDate}
                    emptyValue={defaultEndDate}
                    disableToolbar={true}
                    autoOk={true}
                    format={dateFormat}
                    onChange={(value) => {setToDate(moment(value).format("YYYY-MM-DD"))}}
                  />
                )}
                {field === "dates" && (
                  <>
                    <div style={{paddingLeft: 0, display: "inline-block"}}>
                      <DateSelector
                        label="From Date"
                        style={{width: "100%"}}
                        value={fromDate}
                        emptyValue={defaultStartDate}
                        disableToolbar={true}
                        autoOk={true}
                        format={dateFormat}
                        onChange={(value) => {setFromDate(moment(value).format("YYYY-MM-DD"))}}
                      />
                    </div>
                    <div style={{paddingLeft: 20, display: "inline-block"}}>
                      <DateSelector
                        label="To Date"
                        style={{width: "100%"}}
                        value={toDate}
                        emptyValue={defaultEndDate}
                        disableToolbar={true}
                        autoOk={true}
                        format={dateFormat}
                        onChange={(value) => {setToDate(moment(value).format("YYYY-MM-DD"))}}
                      />
                    </div>
                  </>
                )}
                {field === "excludeAcmi" && (
                  <CheckboxEditor
                    value={excludeAcmi}
                    label="Exclude ACMI Aircraft"
                    labelPosition={"end"}
                    onChange={(value) => {
                      if (value === false)
                        setExcludeAcmi(false)
                      else
                        setExcludeAcmi(true)
                    }}
                  />
                )}
                {field === "scratchPad" && (
                  <>
                    <div style={{display: "block"}}>
                      <CheckboxEditor
                        label="Apply Scratch Pad"
                        labelPosition={"end"}
                        id="applyScratchPad"
                        value={applyScratchPad}
                        onChange={(value) => {
                          setApplyScratchPad(value);
                        }}
                      />
                    </div>
                    <div>
                      {applyScratchPad && (
                        <div style={{paddingLeft: 20, display: "inline-block"}}>
                          <FormSelect
                            label="Scratch Pad User"
                            id="selectScratchPadUser"
                            options={scratchPadUserOptions}
                            onChange={(e) => {
                              const value = e.target.value || user.sub;
                              setScratchPadUser(value);
                            }}
                            value={scratchPadUser||user.sub}
                            style={{width: 200}}
                          />
                        </div>
                      )}
                      {applyScratchPad && (
                        <div style={{paddingLeft: 20, display: "inline-block"}}>
                          <FormSelect
                            label="Scratch Pad"
                            id="selectScratchPad"
                            options={scratchPadOptions}
                            onChange={(e) => {
                              const value = e.target.value || 0;
                              setScratchPad(value);
                            }}
                            value={scratchPad||0}
                          />
                        </div>
                      )}
                    </div>
                  </>
                )}
                {field === "fileTransfer" && (
                  <CheckboxEditor
                    value={fileTransfer}
                    label="Send via File Transfer"
                    labelPosition={"end"}
                    onChange={(value) => {
                      if (value === false)
                        setFileTransfer(false)
                      else
                        setFileTransfer(true)
                    }}
                  />
                )}
                </div>
              ))}
            </div>
            <TripReportCriteriaDialogValidator
              selectionFields={selectionFields}
              airline={airline}
              company={company}
              airport={airport}
              includeAllAircraft={includeAllAircraft}
              aircraftReg={aircraftReg}
              fromDate={fromDate}
              toDate={toDate}
              applyScratchPad={applyScratchPad}
              scratchPadUser={scratchPadUser}
              scratchPad={scratchPad}
              fileTransfer={fileTransfer}
              onChange={(validation) => {
                setTimeout(()=> {
                  setValidationStatus(validation);
                },1);
              }}
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} color="primary">
              Cancel
            </Button>
            <Button onClick={handleSave} disabled={validationState.error} color="primary">
              Select
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  } else {
    return (<></>);
  }
}

export default TripReportCriteriaDialog;
